module.exports = __webpack_public_path__ + "static/media/api_management_services.906802ca.svg";